<div class="p-flex p-flex-col p-h-full p-min-h-full">
  <div class="p-flex p-flex-center-y p-p-xxs">
    <p-button-icon-ghosted-lg icon="arrow-left" (click)="cancel()" />
    <span class="p-text-body">Find & replace</span>
  </div>

  <div class="p-divider"></div>

  <div class="p-flex-col-md p-p-md find-replace-content">
    <div class="p-flex-col-xxs">
      <span class="p-text-desc">Column</span>
      <p-select
        trackBy="id"
        placeholder="Select column"
        [options]="columnOptions"
        [ngModel]="selectedColumn()"
        (ngModelChange)="onColumnChange($event)"
      />
    </div>

    <div class="p-flex-col-xs">
      <div class="p-flex-col-xxs">
        <span class="p-text-desc">Find</span>
        <p-text-input
          [suffixIcon]="hasMatches() ? 'checkmark' : ''"
          [ngModel]="findText()"
          (ngModelChange)="onFindChange($event)"
        />
      </div>
      @if (hasMatches()) {
      <span class="p-text-footnote find-replace-matches">{{ matchCount() | number }} matches</span>
      }
    </div>

    <div class="p-divider"></div>

    <p-tab-bar [block]="true" [selectedId]="mode()" (selectedIdChange)="onModeChange($event)">
      <p-tab-item id="replace">Replace</p-tab-item>
      <p-tab-item id="remove">Remove</p-tab-item>
    </p-tab-bar>
    @if (mode() === 'replace') {
    <div class="p-flex-col-xxs">
      <span class="p-text-desc">Replace with</span>
      <p-text-input [ngModel]="replaceText()" (ngModelChange)="onReplaceChange($event)" />
    </div>
    } @else {
    <div class="p-flex p-flex-between p-flex-center-y">
      <span class="p-text-desc">Remove entire row</span>
      <p-toggle [ngModel]="removeEntireRow()" (ngModelChange)="removeEntireRow.set($event)" />
    </div>
    }
  </div>

  <div class="p-divider"></div>

  <div class="p-flex-col-xs p-px-md p-py-sm find-replace-footer">
    @if (mode() === 'remove') {
    <p-button-warning-md [loading]="isPending" [disabled]="!canApply()" (click)="apply()">
      @if (!isPending) {
      <p-icon-lg icon="delete" />
      } Remove words</p-button-warning-md
    >
    } @else {
    <p-button-primary-md [loading]="isPending" [disabled]="!canApply()" (click)="apply()">
      @if (!isPending) {
      <p-icon-lg icon="cycle" />
      } Replace words</p-button-primary-md
    >
    }
    <p-button-secondary-md (click)="cancel()"> <p-icon-lg icon="cross" />Cancel</p-button-secondary-md>
  </div>
</div>
